import React from "react";
import { Carousel, Card, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import './ProjectItem.scss'

function ProjectItem({ image1, image2, image3, name, id }) {
    const navigate = useNavigate();
    return (
        <div
            className="projectItem"
            onClick={() => {
                navigate("/project/" + id);
            }}
        >

            <div>
                <Col>
                    <Card className="card">
                        <Carousel variant="white">
                            <Carousel.Item>
                                <img
                                    className="d-block w-100"
                                    src={image1}
                                    alt="First slide"
                                />
                            </Carousel.Item>
                            <Carousel.Item>
                                <img
                                    className="d-block w-100"
                                    src={image2}
                                    alt="Second slide"
                                />
                            </Carousel.Item>
                            <Carousel.Item>
                                <img
                                    className="d-block w-100"
                                    src={image3}
                                    alt="Third slide"
                                />
                            </Carousel.Item>
                        </Carousel>

                        <Card.Body className="bg-black">
                            <Card.Title className="text-center text-white">{name}</Card.Title>
                        </Card.Body>

                    </Card>
                </Col>
            </div>


        </div>
    );
}

export default ProjectItem;

